export class SupportSearch {
	constructor(formId = '') {
		this.state = {
			formId,
			keyword: '',
		};

		this.addEventHandlers();
	}

	addEventHandlers() {
		const state = this.state;

		if (!state.formId) {
			return;
		}

		const form = document.querySelector(`#${state.formId} form`);
		if (!form) {
			return;
		}

		form.addEventListener('submit', (e) => this.formSubmitHandler(e));

		const search = form.querySelector('input[name=s]');
		if (search) {
			search.addEventListener('input', (e) => this.searchInputHandler(e));
		}
	}

	formSubmitHandler(e) {
		e.preventDefault();

		this.redirectToResultsPage();
	}

	searchInputHandler(e) {
		const target = e.target;
		const state = this.state;

		state.keyword = target.value;
	}

	redirectToResultsPage() {
		const state = this.state;

		window.location.href = `/support-search-results/?keyword=${state.keyword}`;
	}
}
